// A table printed by a Denzo POS's own "Tables" screen points at that till's
// own LAN address (http://192.168.1.20:8686) — this app is embedded in and
// served BY that till (denzo-pos-desktop/src-tauri/src/lan.rs), so there's
// nothing to look up: the origin the page was served from already *is* the
// store's API. A normal (cloud) store is served from this app's own fixed
// deployment domain instead, looked up server-side by get-store.
//
// One build serves both — nothing else in this app needs to know which case
// it's in. No query param says so (a QR only carries ?store_id=/?table=, see
// TablesQrDialog.js) — the two are told apart by the one thing that actually
// differs and can't be spoofed by a stale param: a till only ever serves
// this page from its own LAN IP, never a domain name.
const IPV4_HOST = /^(\d{1,3}\.){3}\d{1,3}$/;

function resolveLocalOrigin() {
  return IPV4_HOST.test(window.location.hostname) ? window.location.origin : null;
}

export const LOCAL_ORIGIN = resolveLocalOrigin();
export const IS_LOCAL = LOCAL_ORIGIN !== null;

// The till's own LAN gateway serves this app's API at /api/v1/... (see
// lan.rs/selfOrderGateway.js) and product images at /img/... (the same
// image cache denzo-waiter-app's Local mode already uses).
export const API_BASE_URL = IS_LOCAL ? `${LOCAL_ORIGIN}/api/v1/` : process.env.REACT_APP_API_BASE_URL;
export const IMAGE_BASE_URL = IS_LOCAL ? `${LOCAL_ORIGIN}/img/` : process.env.REACT_APP_IMAGE_BASE_URL || "";
